module.exports = __webpack_public_path__ + "img/box-item-icon1.3b05d37d.png";